
import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import {ItemArrayManagerTableHeader} from "@/interface/TableHeader";
import ItemArrayManager from "@/components/common-inputs/ItemArrayManager.vue";
import NafakaAlacakKalemiForm from "@/components/forms/alacak-kalemi/NafakaAlacakKalemiForm.vue";
import AyEkleForm from "@/components/forms/AyEkleForm.vue";
import IlamBilgileriForm from "@/components/forms/alacak/IlamBilgileriForm.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import Dates from "@/components/inputs/Dates.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import IlamliNafakaAlacakFormWizard from "@/components/forms/form-wizard/alacak/IlamliNafakaAlacakFormWizard.vue";
import {IlamTipi} from "@/enum/IlamTipi";
import {AlacakKalemiAlani} from "@/enum/AlacakKalemiAlani";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";
import {HesapSekli} from "@/enum/HesapSekli";
import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import AsilAlacakKalemiForm from "@/components/forms/alacak-kalemi/AsilAlacakKalemiForm.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import {TakipTipi} from "@/enum/TakipTipi";
import {TakipMahiyeti} from "@/enum/TakipMahiyeti";

@Component({
  components: {
    FormDialog, AsilAlacakKalemiForm, DeleteDialog,
    IlamliNafakaAlacakFormWizard,
    ParaBirimiPicker,
    Tutar,
    Dates,
    NafakaAlacakKalemiForm,
    ItemArrayManager,
    IlamBilgileriForm,
    AyEkleForm,
  },
})
export default class IlamliNafakaAlacakForm extends Mixins(ObjectInputMixin) {
  @Prop() takipTipiId!: number;
  @Prop() errorAlacakKalemleri!: boolean;
  @Prop({default:()=>{}}) alacakDetay !: any;
  @Prop({default:()=>[]}) alacakKalemleri!:any
  @Prop() takipTarihliKurlar!: Array<TakipTarihliKurEntity>;

  isWizardComplete: boolean = false;
  mahkemeAdi: string = "";
  ilamTipi = IlamTipi;
  alacakKalemiAlani = AlacakKalemiAlani;
  alacakKalemiDetayData:any = {}
  faizTurleri:any[] =  [];
  paraBirimleri:any[] =  []

  get hasEklenenNafaka(): boolean {
    const items = this.alacakKalemleri.length > 0 ? this.alacakKalemleri : (this.localValue.asil_alacaklar || []);
    return items.some((item: any) => item.alacak_kalemi_alani_id === AlacakKalemiAlani.eklenenNafaka);
  }

  get showNafakaBitisTarihi() {
    const takip = this.$store.state.takipDetay?.takip;
    const ilkTalep = takip?.takip_bilgileri?.talepler?.[0];
    const takipTipiId = ilkTalep?.takip_tipi_id;
    const takipMahiyetiId = ilkTalep?.takip_mahiyeti_id;

    return takipTipiId == TakipTipi.paraBorcuVeyaTeminat
        && (takipMahiyetiId == TakipMahiyeti.nafaka || takipMahiyetiId == TakipMahiyeti.ilamliNafaka);
  }

  async getParaBirimleri(){
    let response = await this.$helper.requestWithCache("/api/v1/para-birimi-picker");
    this.paraBirimleri = response.data;
  }

  async getFaizTurleri(){
    let response = await this.$helper.requestWithCache("/api/v1/faiz-turu/?takibe_ozel_mi=false");
    this.faizTurleri = response.data;
  }
  getTakipOncesiFaizTuruIsim(item:any){
    const faizTuruIsim = this.faizTurleri.find((ft: any) => ft.id === item.takip_oncesi_faiz_turu_id);
    return faizTuruIsim?.isim;
  }
  getTakipSonrasiFaizTuruIsim(item:any){
    const faizTuruIsim = this.faizTurleri.find((ft: any) => ft.id === item.takip_sonrasi_faiz_turu_id);
    return faizTuruIsim?.isim;
  }
  headers = [
    {text: 'Alacak Kalemi Türü', value: 'alacak_kalemi_alani'},
    {text: 'Açıklama', value: 'aciklama'},
    {text: 'Faiz B. Tarihi', value: 'faiz_baslangic_tarihi'},
    {text: 'Takip Öncesi Faiz', value: 'takip_oncesi_faiz_turu'},
    {text: 'Takip Sonrası Faiz', value: 'takip_sonrasi_faiz_turu'},
    {text: 'Tutar', value: 'tutar'},
    {text: 'İşlemler', value: 'actions'},
  ]

  getParaBirimiSembol(paraBirimiId: number){
    const paraBirimi:any = this.paraBirimleri.find((p:any) => p.id === paraBirimiId);
    return paraBirimi ? paraBirimi.kisa_isim : '';
  }

  onAdd(){
    if (this.localValue.id){
      this.$emit('addAlacakKalemi')
    }
  }

  addAsilAlacak(item:any){
    if(!this.localValue.id){
      this.localValue.asil_alacaklar.push(item)
    }else{
      this.onAdd()
    }
  }

  updateAsilAlacak(updatedItem: any, index: number) {
    if (this.localValue.id) {
      this.$emit('addAlacakKalemi');
    } else {
      this.$set(this.localValue.asil_alacaklar, index, updatedItem);
      this.input();
    }
  }
  alacakKalemiDetay(id:any){
    this.$http.get('/api/v1/alacak-kalemi/' + id).then((response)=>{
      this.alacakKalemiDetayData = response.data;
    })
  }

  deleteAsilAlacak(index: number ){
    if (this.localValue.id){
      this.$emit('delete')
    }else{
      this.localValue.asil_alacaklar.splice(index, 1);
    }
  }

  get aciklama() {
    if (this.mahkemeAdi && this.mahkemeAdi != "Ara.." && this.localValue.esas_no && this.localValue.karar_tarihi) {
      let kararTarihi = this.$helper.tarihStr(this.localValue.karar_tarihi ?? "");
      return this.mahkemeAdi + " ’nin " + this.localValue.esas_no + "  E. s.lı dosyasında verilen " + kararTarihi + " tarihli kararı";
    }
  }

  @Watch("aciklama")
  onAciklamaChange() {
    if(!this.localValue.id){
      this.localValue.aciklama = this.aciklama;
      this.input();
    }
  }
  loadAlacakKalemleri(){
    this.$emit('addAlacakKalemi')

  }
  load() {
    this.$emit('load');
  }

  mounted(){
    if (this.localValue.id){
      this.localValue.takip_tarihli_kurlar = this.takipTarihliKurlar;

    }else{
      this.localValue.takip_tarihli_kurlar = []
    }
    this.getFaizTurleri();
    this.getParaBirimleri()

  }
}
